import React from "react";
import { Check, X, Plus } from "lucide-react";

const AllAddressesModal = ({
  isOpen,
  onClose,
  addresses,
  onAddressSelect,
  selectedAddressId,
  onAddAddressClick,
}) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-[9999]">
      <div className="bg-white rounded-lg shadow-xl w-full max-w-2xl mx-4 max-h-[80vh] overflow-hidden flex flex-col">
        {/* HEADER */}
        <div className="sticky top-0 bg-[#242a30] text-white p-4 border-b flex items-center justify-between">
          <div>
            <h2 className="text-lg font-semibold">Your Addresses</h2>
            <p className="text-xs text-gray-300">
              Select an address to deliver
            </p>
          </div>
          <button
            onClick={onClose}
            className="hover:bg-[#232F3E] p-2 rounded-full transition"
          >
            <X className="w-5 h-5" />
          </button>
        </div>

        {/* ADDRESSES LIST */}
        <div className="overflow-y-auto p-4 space-y-3">
          {addresses && addresses.length > 0 ? (
            addresses.map((address) => (
              <div
                key={address._id}
                onClick={() => onAddressSelect(address)}
                className={`p-4 border-2 rounded-lg cursor-pointer transition-all ${
                  selectedAddressId === address._id
                    ? "border-[#e6aa11] bg-yellow-50"
                    : "border-gray-200 hover:border-gray-300"
                }`}
              >
                <div className="flex justify-between items-start gap-3">
                  <div className="flex-1">
                    <div className="flex items-center gap-2 mb-2">
                      <p className="font-semibold text-sm text-gray-900">
                        {address.fullName}
                      </p>
                      <span className="text-xs bg-gray-200 text-gray-700 px-2 py-1 rounded">
                        {address.addressType}
                      </span>
                      {address.isDefault && (
                        <span className="text-xs bg-[#e6aa11] text-[#131921] px-2 py-1 rounded font-bold">
                          DEFAULT
                        </span>
                      )}
                    </div>

                    <p className="text-sm text-gray-700 font-medium">
                      {address.addressLine1}
                    </p>
                    {address.addressLine2 && (
                      <p className="text-sm text-gray-600">
                        {address.addressLine2}
                      </p>
                    )}
                    <p className="text-sm text-gray-600">
                      {address.city}, {address.state} - {address.postalCode}
                    </p>
                    <p className="text-sm text-gray-500">{address.country}</p>
                    {address.landmark && (
                      <p className="text-xs text-gray-500 mt-1">
                        Landmark: {address.landmark}
                      </p>
                    )}
                    <p className="text-sm text-gray-700 mt-2 font-medium">
                      📞 {address.phone}
                    </p>
                  </div>

                  {selectedAddressId === address._id && (
                    <div className="flex-shrink-0 mt-1">
                      <Check className="w-6 h-6 text-[#e6aa11]" />
                    </div>
                  )}
                </div>
              </div>
            ))
          ) : (
            <div className="text-center py-8">
              <p className="text-gray-500 text-sm">No addresses found</p>
            </div>
          )}
        </div>

        {/* FOOTER */}
        <div className="sticky bottom-0 bg-gray-50 border-t p-4 flex gap-2">
          <button
            onClick={() => {
              onAddAddressClick();
              onClose();
            }}
            className="flex-1 px-4 py-2 bg-white text-[#242a30] border-2 border-[#242a30] rounded-md hover:bg-gray-100 font-semibold text-sm transition flex items-center justify-center gap-2"
          >
            <Plus className="w-5 h-5" />
            Add Address
          </button>
          <button
            onClick={onClose}
            className="flex-1 px-4 py-2 bg-[#e6aa11] text-[#131921] rounded-md hover:bg-[#e1a000] font-semibold text-sm transition"
          >
            Done
          </button>
        </div>
      </div>
    </div>
  );
};

export default AllAddressesModal;
